import * as React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import * as randomColor from 'randomcolor';
import * as minuteDiff from 'minute-diff';
import {
  Async,
  Title,
  IconButton,
  Icon,
  NoteList,
  RouteWrapper,
  HolidayUpdateForm,
  Permission,
} from '../../components';
import { getHoliday } from '../../redux/actions/holidays';

interface Props {
  holidays: any;
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  holiday: any;
  ready: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const id = parseInt(this.props.match.params.id, 10);
    this.state = {
      id,
      holiday: find(this.props.holidays.holidays, { id }) || false,
      ready: false,
    };
    this.renderHeading = this.renderHeading.bind(this);
    this.renderDelete = this.renderDelete.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  componentDidMount() {
    const onReady = () => {
      this.setState({ ready: true });
    };
    if (
      !this.state.holiday.lastUpdated ||
      minuteDiff(this.state.holiday.lastUpdated) >= 1
    ) {
      this.props.dispatch(getHoliday(this.state.id)).then((response) => {
        this.setState({ holiday: response.data });
        onReady();
      });
    } else {
      onReady();
    }
  }

  renderHeading() {
    return (
      <div className="level-left">
        {this.state.holiday.id && (
          <span
            className="avatar image is-64x64"
            style={{
              backgroundColor: randomColor({
                seed: this.state.holiday.id * 2500,
                luminosity: 'light',
              }),
            }}
          >
            <Icon icon="calendar" size="large" />
          </span>
        )}
        <Async on={this.state.ready}>
          <Title>{this.state.holiday.name || 'Holiday'}</Title>
        </Async>
      </div>
    );
  }

  renderDelete() {
    return (
      <Permission require="MANAGE_DELETIONS">
        <div className="level-right">
          <IconButton
            link={`/settings/holidays/${this.state.id}/delete`}
            className="is-danger"
            icon="trash"
          >
            Delete
          </IconButton>
        </div>
      </Permission>
    );
  }

  renderBody() {
    if (this.state.ready) {
      return (
        <HolidayUpdateForm
          id={this.state.id}
          item={this.state.holiday}
          onUpdate={() => {
            window.history.back();
          }}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <RouteWrapper
        title={this.state.holiday.name || 'Holiday'}
        requireAuth
        requirePermission="MANAGE_HOLIDAYS"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/holidays', text: 'Holidays' },
          {
            link: '/settings/holidays/:id',
            text: this.state.holiday.name || 'Holiday',
          },
        ]}
        loading={this.props.holidays.isFetching}
        error={!this.state.ready && this.props.holidays.error}
      >
        <div className="container">
          <div className="columns is-multiline">
            <div className="column is-12-desktop is-7-widescreen">
              <div className="level">
                {this.renderHeading()}
                {this.renderDelete()}
              </div>
              {this.renderBody()}
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <NoteList resource="holidays" id={this.state.id} />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ holidays }) => ({
  holidays,
});

export default connect(mapStateToProps)(Route);
